import petrBromnik from "@assets/images/members/bromnik-petr.jpeg?w=250&webp&imagetools";
import ondrejCzubaj from "@assets/images/members/czubaj-ondrej.jpg?w=250&webp&imagetools";
import jakubHyza from "@assets/images/members/hyza-jakub.jpeg?w=250&webp&imagetools";
import adrianaJackova from "@assets/images/members/jackova-adriana.jpg?w=250&webp&imagetools";
import richardJelinek from "@assets/images/members/jelinek-richard.jpg?w=250&webp&imagetools";
import martinKucera2025suit from "@assets/images/members/kucera-martin-2025.jpg?w=300&webp&imagetools";
import mojmirKyjonka from "@assets/images/members/kyjonka-mojmir.jpg?w=250&webp&imagetools";
import nelaLetochova from "@assets/images/members/letochova-nela.jpg?w=250&webp&imagetools";
import davidMacek from "@assets/images/members/macek-david.jpg?w=250&webp&imagetools";
import jakubMacek from "@assets/images/members/macek-jakub.jpeg?w=250&webp&imagetools";
import janMozny from "@assets/images/members/mozny-jan.jpeg?w=250&webp&imagetools";
import janOulehla from "@assets/images/members/oulehla-jan.jpg?w=250&webp&imagetools";
import tomasPala from "@assets/images/members/pala-tomas.jpg?w=250&webp&imagetools";
import denisPys from "@assets/images/members/pys-denis.jpg?w=250&webp&imagetools";
import romanSvejda from "@assets/images/members/roman-svejda.jpg?w=300&webp&imagetools";
import michalSimon from "@assets/images/members/simon-michal.jpeg?w=250&webp&imagetools";
import radekSotkovsky from "@assets/images/members/sotkovsky-radek-2025.jpg?w=250&webp&imagetools";
import jakubTyson from "@assets/images/members/tyson-jakub.jpg?w=250&webp&imagetools";
import matejVenglar from "@assets/images/members/venglar-matej.jpg?w=250&webp&imagetools";
import tomasWrobel from "@assets/images/members/wrobel-tomas.jpg?w=250&webp&imagetools";
import type { ContactPerson } from "@components/ContactPerson.js";
import type { Tenant } from "@core/schema/Tenant.js";

export enum TeamMemberType {
	Internist = "Internist",
	Externist = "Externist",
}

export function getTeamMembers(tenant: Tenant): ContactPerson[] {
	return [
		{
			name: "Martin Kučera",
			role: "CEO",
			photo: martinKucera2025suit,
			// photo: martinKucera2025suit,
			phone: "+420 773 050 550",
			email: "kucera@fastest.cz",
			linkedin: "kucera-martin",
			type: TeamMemberType.Internist,
			board: true,
			show: true,
		},
		{
			name: "Roman Švejda",
			role: "Delivery Manager",
			type: TeamMemberType.Internist,
			photo: romanSvejda,
			show: true,
		},
		{
			name: "Richard Jelínek",
			role: "Team Lead Developer",
			photo: richardJelinek,
			type: TeamMemberType.Internist,
			show: true,
		},
		{
			name: "Nela Letochová",
			role: "Frontend Developer",
			photo: nelaLetochova,
			type: TeamMemberType.Internist,
			show: true,
		},
		{
			name: "Tomáš Pala",
			role: "QA Engineer & Tech support",
			photo: tomasPala,
			type: TeamMemberType.Internist,
			show: true,
		},
		{
			name: "David Macek",
			role: "Architect, Analyst & Developer",
			photo: davidMacek,
			type: TeamMemberType.Internist,
			show: true,
		},
		{
			name: "Michal Šimon",
			role: "DevOps Engineer",
			photo: michalSimon,
			type: TeamMemberType.Externist,
			show: false,
		},
		{
			name: "Mojmír Kyjonka",
			role: "Fullstack Developer",
			photo: mojmirKyjonka,
			type: TeamMemberType.Internist,
			show: true,
		},
		{
			name: "Jakub Tysoň",
			role: "Co-founder & Developer",
			photo: jakubTyson,
			type: TeamMemberType.Internist,
			show: true,
		},
		{
			name: "Radek Šotkovský",
			role: "Fullstack Developer",
			photo: radekSotkovsky,
			type: TeamMemberType.Internist,
			show: true,
		},
		{
			name: "Petr Bromnik",
			role: "Frontend Developer",
			photo: petrBromnik,
			type: TeamMemberType.Internist,
			show: false,
		},
		{
			name: "Adriána Jacková",
			role: "QA Engineer",
			photo: adrianaJackova,
			type: TeamMemberType.Internist,
			show: true,
		},
		{
			name: "Tomáš Wróbel",
			role: "Junior Developer",
			photo: tomasWrobel,
			type: TeamMemberType.Internist,
			show: true,
		},
		{
			name: "Dan Friedlaender",
			role: "UI Designer",
			type: TeamMemberType.Externist,
			show: true,
		},
		{
			name: "Ondřej Czubaj",
			role: "UI Designer",
			photo: ondrejCzubaj,
			type: TeamMemberType.Externist,
			show: true,
		},
		{
			name: "Jakub Hýža",
			role: "Frontend Developer",
			photo: jakubHyza,
			type: TeamMemberType.Internist,
			show: false,
		},
		{
			name: "Jakub Macek",
			role: "Analyst",
			photo: jakubMacek,
			type: TeamMemberType.Externist,
			show: false,
		},
		{
			name: "Jan Možný",
			role: "Junior Developer",
			photo: janMozny,
			type: TeamMemberType.Internist,
			show: false,
		},
		{
			name: "Denis Pyš",
			role: "Junior Developer",
			photo: denisPys,
			type: TeamMemberType.Internist,
			show: true,
		},
		{
			name: "Jiří Niziol",
			role: "Project Manager",
			type: TeamMemberType.Internist,
			show: false,
		},
		{
			name: "Matěj Venglář",
			role: "Trainee",
			photo: matejVenglar,
			type: TeamMemberType.Internist,
			show: false,
		},
		{
			name: "Roman Tarnai",
			role: "Junior Developer",
			type: TeamMemberType.Internist,
			show: false,
		},
		{
			name: "Jan Oulehla",
			role: "Junior Developer",
			photo: janOulehla,
			type: TeamMemberType.Internist,
			show: true,
		},
		{
			name: "Sára Hýžová",
			role: "Fullstack Developer",
			type: TeamMemberType.Internist,
			show: true,
		},
		{
			name: "Jonáš Brauer",
			role: "Fullstack Developer",
			type: TeamMemberType.Internist,
			show: true,
		},
		{
			name: "Adéla Hrazdílková",
			role: "Project Manager",
			type: TeamMemberType.Internist,
			show: false,
		},
		{
			name: "Michal Kubricht",
			role: "Backend Developer",
			type: TeamMemberType.Externist,
			show: false,
		},
		{
			name: "Vojtěch Beil",
			role: "Backend Developer",
			type: TeamMemberType.Externist,
			show: true,
		},
		{
			name: "Martin Schwarz",
			role: "Copywriter",
			type: TeamMemberType.Externist,
			show: false,
		},
		{
			name: "Martina Libřická",
			role: "SEO Specialist",
			type: TeamMemberType.Externist,
			show: false,
		},
		{
			name: "Simona Hůrková",
			role: "UI/UX Designer",
			type: TeamMemberType.Externist,
			show: false,
		},
		{
			name: "Tomáš Hrabec",
			role: "UX Designer",
			type: TeamMemberType.Externist,
			show: false,
		},
	];
}
